module.exports = __webpack_public_path__ + "static/media/5DPO14.e1c92f51.jpg";